import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { KHATTABAT_FUNNEL_STATS_DEFAULT_DATA } from "../../constants/input-entries-constants";
import { getDateAsObject } from "../../core/et3-date";
import { TKhattabatFunnelStatsData } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetFunnelStatsData = async ({
  startDate,
  endDate
}: {
  startDate: Date;
  endDate: Date;
}): Promise<{
  data: TKhattabatFunnelStatsData;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TKhattabatFunnelStatsData>(
    `supervisor/getKhattabatFunnelStatsData`,
    {
      startDateObject: getDateAsObject(startDate),
      endDateObject: getDateAsObject(endDate)
    }
  );
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (
    status === "ERROR" &&
    isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      et3Error
    )
  ) {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: KHATTABAT_FUNNEL_STATS_DEFAULT_DATA,
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: KHATTABAT_FUNNEL_STATS_DEFAULT_DATA,
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  }
};
